import { DisplayPageType } from '@faire/web-api--source/indigofair/data/DisplayPageType';

export namespace IViewLoggingData {
  /**
   * Return an instance of IViewLoggingData with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IViewLoggingData>
  ): IViewLoggingData =>
    ({
      ...(partial ?? {}),
    }) as IViewLoggingData;
}

/**
 * Logging data relating the SD UI view and all children
 */
export interface IViewLoggingData {
  /**
   * A enum representing the surface of the view
   */
  view_display_page: keyof typeof DisplayPageType | undefined;
  /**
   * A value used to distinguish views of the same display page type from each other.
   * For example, the category path identifier for a Category Page or a product token for a Product Page
   */
  view_instance_identifier: string | undefined;
  /**
   * A unique identifier for the generated view instance. Used for caching purposes
   * @protobufOption (faire.common.diffIgnore) = ALWAYS
   */
  request_id: string | undefined;
  /**
   * A human-readable unique identifier for the SDUI container meant to differentiate between
   * multiple distinct SDUI containers on a screen (for example, a page that has 2 separate
   * SDUI containers perhaps rendered in the header and footer of the page could fill this
   * field as {page_name}_header_view_layout and {page_name}_footer_view_layout.
   * The difference between containerIdentifier and the viewInstanceIdentifier above is that
   * containerIdentifier is meant to distinguish between 2 containers on a single page,
   * viewInstanceIdentifier is meant to distinguish between pages.
   * ex/ if you had 2 distinct SDUI containers on a PDP, the viewInstanceIdentifier
   * would be the product token for both ViewLayouts, the containerIdentifier would
   * differentiate the 2 ViewLayouts (top container and bottom container for example)
   */
  container_identifier: string | undefined;
}
